import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './languages';

const savedLanguage = localStorage.getItem('language') || 'si';
const isSupported = SUPPORTED_LANGUAGES.some(
  (l) => l.code === savedLanguage && !l.disabled
);

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: isSupported ? savedLanguage : DEFAULT_LANGUAGE,
  resources: {
    en: {
      translation: require('./locales/en/translation.json')
    },
    si: {
      translation: require('./locales/si/translation.json')
    },
    ta: {
      translation: require('./locales/ta/translation.json')
    },
    hi: {
      translation: require('./locales/hi/translation.json')
    }
  },
  interpolation: {
    escapeValue: false
  }
});

export default i18n;